import { Trans, useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';
import { selectSiteHeaderData } from '../../../../../../../store/features/siteHeader';
import Modal from '../../../../../../shared/Modal/Modal';
import ModalEventPartners from '../../../../../../shared/ModalEventPartners/ModalEventPartners';
import RadioGroupField from '../../../../../../paymentJourneyRedesign/shared/formElements/RadioGroupField';
import CheckboxField from '../../../../../../paymentJourneyRedesign/shared/formElements/CheckboxField';
import Radio from '../../../../../../paymentJourneyRedesign/shared/library/Radio';
import { renderAgreementMessage } from '../../../../../../shared/renderAgreementMessage';
import { useGetTermsAndConditionsUrl } from '../../../../../../../hooks/useGetTermsAndConditionsUrl';
import s from './ConsentForm.module.scss';

const Anchor = (props) => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a {...props} />;
};
const ModalLink = Modal(Anchor, ModalEventPartners);

export default function ConsentForm({ data }) {
  const { id, fallbackQuestion, agreementMessage, checkboxes = [] } = data;

  const { t } = useTranslation();
  const { title: eventName } = useRootSelector(selectSiteHeaderData);
  const {
    tenantConfig: { name: tenantName },
  } = useRootSelector(selectPageConfig);

  const termsAndConditionsUrl = useGetTermsAndConditionsUrl();

  return (
    <div className={s.wrapper}>
      {agreementMessage && (
        <div className={s.agreementCheckbox}>
          <CheckboxField
            name={`userConsentAgreements.${id}`}
            rules={{ required: true }}
            label={renderAgreementMessage(
              agreementMessage,
              termsAndConditionsUrl,
            )}
          />
        </div>
      )}
      <div className={s.fallbackQuestion}>
        <Trans
          values={{
            eventName,
            tenantName,
            eventPartners: t('leadGen.third-party-header.content-partners'),
            partners: t('leadGen.third-party-header.partners'),
          }}
          components={[
            <ModalLink
              withTopPanel
              style={{
                textDecoration: 'underline',
                cursor: 'pointer',
                textTransform: 'lowercase',
              }}
            />,
          ]}
        >
          {fallbackQuestion}
        </Trans>
      </div>
      {checkboxes.length > 0 && (
        <div className={s.boxesWrapper}>
          <div className={s.checkboxes}>
            {checkboxes.map(({ name, label }) => (
              <div key={name} className={s.channel}>
                <RadioGroupField
                  name={`${id}.${name}`}
                  label={label}
                  rules={{ required: true }}
                  row
                >
                  <Radio value="true" label="Yes" />
                  <Radio value="false" label="No" />
                </RadioGroupField>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
